import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  
  {
    path : '/',
    name : 'AdminApp',
    component : () => import('../views/AppMain.vue')
  },


  {
    path : '/login',
    name : 'LoginView',
    component : () => import('../views/LoginView.vue')
  },


  {
    path : '/admin/tokens',
    name : 'AdminTokens',
    component : () => import('../views/AdminTokens.vue')
  },

  {
    path : '/admin/users',
    name : 'AdminUsers',
    component : () => import('../views/AdminUsers.vue')
  },

  {
    path : '/admin/services',
    name : 'AdminServices',
    component : () => import('../views/AdminServices.vue')
  },

  {
    path : '/admin/certs',
    name : 'AdminCerts',
    component : () => import('../views/AdminCerts.vue')
  },

  {
    path : '/admin/cert/upload',
    name : 'AdminCertUpload',
    component : () => import('../views/AdminCertUploadView.vue')
  },

  {
    path : '/user/cert/upload',
    name : 'userCertUpload',
    component : () => import('../views/userUpload.vue')
  },

  {
    path : '/user/cert/upload/done',
    name : 'userCertUploadDone',
    component : () => import('../views/userUploadDone.vue')
  }




]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
